if (!window.trustvilleReviewsLoaded) {
  window.trustvilleReviewsLoaded = true;
  
  document.addEventListener('DOMContentLoaded', function() {
    const reviewsContainer = document.querySelector('[data-trustville-reviews]');
    const contentContainer = document.querySelector('[data-trustville-content]');
    
    if (!reviewsContainer || !contentContainer) return;

    function renderStars(rating, maxRating = 5) {
      const fullStars = Math.floor(rating);
      const hasHalfStar = rating % 1 >= 0.5;
      const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);
      
      const fullStarUrl = reviewsContainer.dataset.fullStarUrl;
      const emptyStarUrl = reviewsContainer.dataset.emptyStarUrl;
      
      let starsHtml = '<div class="trustville-reviews__stars" role="img" aria-label="' + rating + ' sur ' + maxRating + '">';
      
      // Full stars
      for (let i = 0; i < fullStars; i++) {
        starsHtml += '<img src="' + fullStarUrl + '" alt="star" class="trustville-reviews__star trustville-reviews__star--full" width="10" height="10" />';
      }
      
      // Half star
      if (hasHalfStar) {
        starsHtml += '<img src="' + fullStarUrl + '" alt="half star" class="trustville-reviews__star trustville-reviews__star--half" width="10" height="10" style="clip-path: inset(0 50% 0 0);" />';
      }
      
      // Empty stars
      for (let i = 0; i < emptyStars; i++) {
        starsHtml += '<img src="' + emptyStarUrl + '" alt="empty star" class="trustville-reviews__star trustville-reviews__star--empty" width="10" height="10" />';
      }
      
      starsHtml += '</div>';
      return starsHtml;
    }

    /**
     * Fetch reviews data from custom app API
     */
    async function fetchTrustvilleData() {
      try {
        const response = await fetch('/apps/spapp/trustville/reviews');
        
        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }
        
        const data = await response.json();
        
        if (data && data.rating_average && data.rating_count) {
          renderReviews(data);
        } else {
          hideReviews();
        }
      } catch (error) {
        console.error('Trustville reviews error:', error);
        hideReviews();
      }
    }

    
    function renderReviews(data) {
      const { rating_average, rating_count, trustville_uri } = data;
      const trustvilleUrl = trustville_uri || '#';
      
      // Get translations from data attributes
      const ratingText = reviewsContainer.dataset.ratingText.replace('__RATING__', rating_average.toFixed(1));
      const reviewCountText = reviewsContainer.dataset.reviewCount.replace('__COUNT__', rating_count);
      
      const reviewsHtml = `
        <a href="${trustvilleUrl}" class="trustville-reviews__link" target="_blank" rel="noopener noreferrer">
          ${renderStars(rating_average, 5)}
          <span class="trustville-reviews__rating-number">${rating_average.toFixed(1)}</span>
          <p class="trustville-reviews__text">
            <span class="trustville-reviews__rating">${ratingText}</span>
            <span class="trustville-reviews__count">${reviewCountText}</span>
          </p>
        </a>
      `;
      
      contentContainer.innerHTML = reviewsHtml;
    }

    /**
     * Hide reviews section if no data is available
     */
    function hideReviews() {
      if (reviewsContainer) {
        reviewsContainer.style.display = 'none';
      }
    }

    // Initialize module
    fetchTrustvilleData();
  });
}
